import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

import { Job } from '@libs/graphql-types';
import StepSection from '@libs/ui/components/step-section';

import { QualificationControl } from './QualificationControl';
import { Qualification } from './types';

interface QualificationsSectionProps {
  job: Job;
  sectionName: string;
  index: number;
  showOnlyRequired?: boolean;
}

export const QualificationsSection = ({
  job,
  sectionName,
  index,
  showOnlyRequired = false,
}: QualificationsSectionProps) => {
  const { t } = useTranslation('jobForm');
  const qualifications: Qualification[] = JSON.parse(
    job?.striive_job?.qualifications || '[]',
  );

  const filteredQualifications = showOnlyRequired
    ? qualifications.filter((q) => q.mandatory)
    : qualifications;

  return (
    <StepSection index={index} title={t('applicationForm.qualifications.title')}>
      <Grid spacing={4} direction="column" container>
        {filteredQualifications.map((qualification) => (
          <Grid item key={qualification.id}>
            <QualificationControl
              qualification={qualification}
              name={`${sectionName}.${qualification.recordId}`}
            />
          </Grid>
        ))}
      </Grid>
    </StepSection>
  );
};
